import React from 'react';
import PropTypes from 'prop-types';
import AlertFail from '@learningblocks/exp-constants/lib/Icons/alert-large-fail';
import AlertSuccess from '@learningblocks/exp-constants/lib/Icons/alert-large-success';
import CloseButton from '@learningblocks/exp-constants/lib/Icons/incorrect-relative';
import './style.scss';

const FEEDBACK_TYPE = {
  SUCCESS: {
    icon: AlertSuccess,
    message: 'Prediction submitted!',
  },
  FAIL: {
    icon: AlertFail,
    message: "Don't forget to drag all the bands!",
  },
};

export function Feedback(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.onClose(event);
  };

  if (props.type) {
    const {icon, message} = FEEDBACK_TYPE[props.type];
    return (
      <div
        className={`geldragdropquestion_feedback ${props.type.toLowerCase()}`}>
        {React.createElement(icon, {
          className: 'geldragdropquestion_feedback__icon',
        })}
        {React.createElement(
          'p',
          {className: 'geldragdropquestion_feedback__message'},
          message
        )}
        <CloseButton
          className='geldragdropquestion_feedback__close'
          onClick={onClick}
        />
      </div>
    );
  } else {
    return null;
  }
}

Feedback.propTypes = {
  /**
   * Type of Feedback to display [if dype id null will not show feedback]
   */
  type: null || PropTypes.oneOf(['SUCCESS', 'FAIL']),
  /**
   * Function to invoke on click of close button
   */
  onClose: PropTypes.func,
};

Feedback.defaultProps = {
  type: null,
};
